var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview",staticStyle:{"height":"100vh"}},[_c('object',{staticStyle:{"overflow":"hidden","height":"100%","width":"100%"},attrs:{"data":'data:application/pdf;base64,' + _vm.pdfB64,"type":"application/pdf","height":"100%","width":"100%"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c1a4316","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomePage/Preview.vue
// module id = null
// module chunks = 